/**
 * Created by fky on 3/2/2017.
 */

'use strict';
angular.module('fmsDashboard', ['ui.router']).config(function ($stateProvider) {
  $stateProvider
    .state('fmsdashboard',{
      parent: 'betotrack',
      url: '/fmsdashboard',
      ncyBreadcrumb: {
        label: 'Track'
      },
      views: {
        'content@app': {
          templateUrl: 'components/dashboard/fmsDashboard/fmsDashboard.tpl.html',
          controller: 'FmsDashboardCtrl'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Fleet Management Dashboard';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/fmsDashboard/fmsDashboard.js